var moduleMap = {
	"./FuturesTableWidget": () => {
		return Promise.all([__webpack_require__.e(724), __webpack_require__.e(97), __webpack_require__.e(91), __webpack_require__.e(140), __webpack_require__.e(945), __webpack_require__.e(39), __webpack_require__.e(48), __webpack_require__.e(304), __webpack_require__.e(586), __webpack_require__.e(434)]).then(() => (() => ((__webpack_require__(7740)))));
	},
	"./DayAheadTablesWidget": () => {
		return Promise.all([__webpack_require__.e(724), __webpack_require__.e(29), __webpack_require__.e(97), __webpack_require__.e(140), __webpack_require__.e(945), __webpack_require__.e(39), __webpack_require__.e(48), __webpack_require__.e(215), __webpack_require__.e(888), __webpack_require__.e(630), __webpack_require__.e(548)]).then(() => (() => ((__webpack_require__(1974)))));
	},
	"./AverageDayAheadWidget": () => {
		return Promise.all([__webpack_require__.e(331), __webpack_require__.e(724), __webpack_require__.e(29), __webpack_require__.e(97), __webpack_require__.e(140), __webpack_require__.e(945), __webpack_require__.e(39), __webpack_require__.e(48), __webpack_require__.e(215), __webpack_require__.e(53), __webpack_require__.e(687)]).then(() => (() => ((__webpack_require__(940)))));
	},
	"./MarketIndexTableWidget": () => {
		return Promise.all([__webpack_require__.e(331), __webpack_require__.e(724), __webpack_require__.e(140), __webpack_require__.e(945), __webpack_require__.e(39), __webpack_require__.e(673), __webpack_require__.e(122)]).then(() => (() => ((__webpack_require__(6892)))));
	},
	"./ARACoalTableWidget": () => {
		return Promise.all([__webpack_require__.e(331), __webpack_require__.e(724), __webpack_require__.e(140), __webpack_require__.e(945), __webpack_require__.e(304), __webpack_require__.e(660), __webpack_require__.e(529)]).then(() => (() => ((__webpack_require__(9017)))));
	},
	"./IntradayAuctionsTableWidget": () => {
		return Promise.all([__webpack_require__.e(724), __webpack_require__.e(29), __webpack_require__.e(97), __webpack_require__.e(140), __webpack_require__.e(945), __webpack_require__.e(39), __webpack_require__.e(48), __webpack_require__.e(215), __webpack_require__.e(888), __webpack_require__.e(238), __webpack_require__.e(268)]).then(() => (() => ((__webpack_require__(7268)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});